import { createFileRoute } from '@tanstack/react-router'

import { CreateBookingWizard } from '@/widgets/create-booking-wizard'

export const Route = createFileRoute('/_dashboard/branch/$branchId/create/_wizard')({
    component: CreateBookingWizard,
})
